module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 63
// module chunks = 0